import {
    SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_FAILED,
    SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS
} from "./CustomerOrderNumberConstants";

const initialState = {
    orderNumbers: [],
    searchError: false
}

const reducer = (state = initialState, action) => {
    switch (action.type) {

        case SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_SUCCESS:
            return {
                ...state,
                orderNumbers: action.payload,
                searchError: false
            }

        case SEARCH_CUSTOMER_ORDER_NUMBER_REQUEST_FAILED:
            return {
                ...state,
                orderNumbers: [],
                searchError: true
            }
        default:
            return state

    }
}

export default reducer;
